const system = {
  state: {
    menuIsCollapse: false,
    messageList: {}
  },
  mutations: {
    SET_MENU_COLLAPSE (state, status) {
      state.menuIsCollapse = status
    },
    SET_MESSAGE_LIST (state, status) {
      state.messageList = status
    }
  }
}

export default system



// WEBPACK FOOTER //
// ./src/store/modules/system.js